import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function ODEs(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>ODEs</h2>
                <li>
                    <Link to={`${url}/odes`}>ODEs</Link>
                </li>
                <li>
                    <Link to={`${url}/fourier`}>Fourier Transforms</Link>
                </li>
                <li>
                    <Link to={`${url}/first`}>1st Order Equations</Link>
                </li>
                <li>
                    <Link to={`${url}/second`}>2nd Order Equations</Link>
                </li>
                <li>
                    <Link to={`${url}/powerseries`}>Power Series</Link>
                </li> 
                <li>
                    <Link to={`${url}/laplace`}>Laplace Transforms</Link>
                </li>    
                   <li>
                    <Link to={`${url}/ztransform`}>Z-Transforms</Link>
                </li>            
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default ODEs; 